import { render, staticRenderFns } from "./landing.vue?vue&type=template&id=923853f4&"
import script from "./landing.vue?vue&type=script&lang=ts&"
export * from "./landing.vue?vue&type=script&lang=ts&"
import style0 from "./landing.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports